import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-deleteaccountdialog',
  templateUrl: './deleteaccountdialog.component.html',
  styleUrls: ['./deleteaccountdialog.component.scss']
})
export class DeleteaccountdialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeleteaccountdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog) { }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

}
